import { useTranslation } from 'next-i18next';
import * as yup from 'yup';

export const useRegisterSchema = () => {
    const { t } = useTranslation('auth');

    return yup.object().shape({
        name: yup
            .string()
            .required(t('text_name_required', 'Vui lòng nhập tên Ba mẹ'))
            .matches(/^[\p{L}\s]{1,255}$/u, t('text_name_invalid_format'))
            .test(
                'full-name-min-words',
                t('text_name_min_two_words', 'Vui lòng nhập đầy đủ họ và tên (ít nhất 2 từ)'),
                value => {
                    if (!value) return false;
                    const words = value.trim().split(/\s+/);
                    return words.length >= 2;
                }
            )
            .test('meaningless-words', t('text_name_invalid_words'), value => !value || !/\b(\p{L})\1\b/iu.test(value)),
        email: yup
            .string()
            .notRequired()
            .transform(value => (value === '' ? undefined : value))
            .email(t('text_email_invalid_format')),
    });
};
